import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useXFetch } from '~/shared/utils/useXFetch';
import { toaster } from '~/shared/utils/toaster';

import type { CreateRuleExclusionResponse } from '~/shared/types/api';

interface CreateExceptionParams {
  volumeId: string;
  ruleId: string;
}

export function useCreateException() {
  const api = useXFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      volumeId,
    }: CreateExceptionParams): Promise<CreateRuleExclusionResponse> => {
      const response = await api(`/api/v1/volumes/${volumeId}/autoscaling/rules/exclusions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response as CreateRuleExclusionResponse;
    },
    onSuccess: () => {
      // Success handling moved to component level
    },
    onError: (error) => {
      console.error('Failed to create exception:', error);
      toaster({
        variant: 'error',
        title: 'Error',
        message: 'Failed to create exception. Please try again.',
      });
    },
  });
}
